import React, { FC } from 'react';
import { DateRangePicker } from 'react-date-range';
import './styles.scss';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

export type SelectionRangeType = {
  startDate: Date;
  endDate: Date;
  key?: string;
};

type DateProps = {
  selectionRange: SelectionRangeType;
  handleSelect: (ranges: object) => void;
};
const DatePicker: FC<DateProps> = ({ selectionRange, handleSelect }) => {
  return (
    <div className='react-calendar flex justify-center'>
      <DateRangePicker
        ranges={[selectionRange]}
        onChange={handleSelect}
        // maxDate={new Date()}
        // direction='horizontal'
        // months={2}
        // showSelectionPreview={false}
        moveRangeOnFirstSelection={false}
        editableDateInputs={true}
        className='!shadow-none'
        // showMonthArrow={false}
        color={'#000000'}
        // dateDisplayFormat="dd/MM/yyyy"
      />
    </div>
  );
};

export default DatePicker;
